module.exports = __webpack_public_path__ + "img/ontology-pro-tips-knowledge-graph.74127e0a.png";